export const truncateText = (
  text: string,
  maxTextLength: number,
  shouldTruncate: boolean = true,
) => {
  return {
    truncatedText:
      shouldTruncate && text.length > maxTextLength
        ? `${text.slice(0, maxTextLength)}...`
        : text,
    isTruncated: shouldTruncate ? text.length > maxTextLength : false,
    originalText: text,
  };
};
